import React, { Component } from "react";
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import { change } from "redux-form";

import ImageUploadComponent from "../../ImageUploadComponent/ImageUploadComponent";
import CommonImageDisplay from '../../CommonImageDisplay/CommomImageDisplay';

import { setLoaderComplete, setLoaderStart } from "../../../../actions/loader/loader";
import messages from '../../../../locale/jsonMessages';
import { photosShow } from "../../../../helpers/photosShow";
import { ogImageuploadDir } from "../../../../config";

import bt from '../../../../components/commonStyle.css';
import s from './OgImageUploader.css';

class OgImageUploder extends Component {
    static propTypes = {
        prop: PropTypes,
    }

    render() {
        const { loader, image } = this.props;
        const { formatMessage } = this.props.intl;
        let path = photosShow(ogImageuploadDir);

        return (
            <div>

                <CommonImageDisplay
                    image={image && path + image}
                    isDefaultPic={image ? false : true}
                    loader={loader}
                    isDelete={false}
                />

                <ImageUploadComponent
                    defaultMessage={formatMessage(messages.clickHeretoUploadImage)}
                    componentConfig={{
                        iconFiletypes: ['.jpg', '.png'],
                        multiple: false,
                        showFiletypeIcon: false,
                        postUrl: '/uploadOgImage'
                    }}
                    loaderName={'ogImage'}
                    imageName={'ogImage'}
                    className={bt.spaceTop3}
                />
            </div>
        )
    }
}

const mapState = (state) => ({
    loader: state?.loader?.ogImage
})

const mapDispatch = {
    change,
    setLoaderStart,
    setLoaderComplete
}

export default compose(
    injectIntl,
    withStyles(bt, s),
    connect(mapState, mapDispatch),
)(OgImageUploder);